import React from 'react';
import objectHash from 'object-hash';
import PropTypes from 'prop-types';
import { Row, Column } from 'components/shared/Layout';
import { passengerShape } from 'constants/propTypes';
import { SelectedSeat, StyledSeatSelectionWrapper, StyledSeat } from './GroupBookingSeatSelection.styles';

const GroupBookingSeatSelection = ({
  seatsToShow,
  selectedPassenger,
  selectedPassengers,
  selectedSeats,
  onRemovePassengerSelection,
  onSelectNewPassenger
}) => (
  <StyledSeatSelectionWrapper numberOfRows={Math.ceil(selectedSeats.length / 10)}>
    {[...Array(Math.ceil(seatsToShow.length / 10))].map((_, rowIndex) => (
      <Row span={10} columns={10} key={rowIndex}>
        {seatsToShow.slice(rowIndex * 10, rowIndex * 10 + 10).map((selectedSeat) => {
          const selected =
            (selectedPassenger && selectedSeat.passenger.id === selectedPassenger.id) ||
            (selectedPassengers?.length && selectedPassengers.some(({ id }) => selectedSeat.passenger.id === id));
          const seatIndex = selectedSeats.indexOf(selectedSeat) + 1;
          const coach = parseInt(selectedSeat.coach, 10);
          const seatNumber = parseInt(selectedSeat.number, 10);

          return (
            <Column span={1} key={objectHash(selectedSeat)}>
              <StyledSeat>
                <div className="seat-index">{`${seatIndex}. `}</div>
                <SelectedSeat
                  data-cy={`seat-select-${coach}-${parseInt(seatNumber, 10)}`}
                  className={selected && 'selected'}
                  selected={selected}
                  onClick={() =>
                    selected ? onRemovePassengerSelection(selectedSeat.passenger.id) : onSelectNewPassenger(selectedSeat.passenger.id)
                  }
                >{`${coach} / ${parseInt(seatNumber, 10)}`}</SelectedSeat>
              </StyledSeat>
            </Column>
          );
        })}
      </Row>
    ))}
  </StyledSeatSelectionWrapper>
);

GroupBookingSeatSelection.propTypes = {
  selectedSeats: PropTypes.arrayOf(
    PropTypes.shape({
      passenger: PropTypes.shape({
        id: PropTypes.string
      }),
      number: PropTypes.string,
      coach: PropTypes.string
    })
  ),
  onSelectNewPassenger: PropTypes.func,
  selectedPassenger: passengerShape,
  selectedPassengers: PropTypes.arrayOf(passengerShape),
  onRemovePassengerSelection: PropTypes.func,
  seatsToShow: PropTypes.arrayOf(
    PropTypes.shape({
      passenger: PropTypes.shape({
        id: PropTypes.string
      })
    })
  )
};

export default GroupBookingSeatSelection;
